import { Chapter, SubTitle, Body } from "@/components/Chapter";
import { FinTable } from "@/components/FinTable";
import { AppreciationChart } from "@/components/Charts";

export const Valor = ({ d }) => (
  <>
    <Chapter id="13" num="13" title="Revalorización del Inmueble">
      <div className="space-y-0 border-l-2 border-gold/50 pl-6">
        {d.revalorizacion.fases.map((f, i) => (
          <div key={f.rango} data-testid={`fase-item-${i}`} className="relative pb-8 last:pb-0">
            <span className="absolute -left-[31px] top-1 h-2.5 w-2.5 rotate-45 border border-gold bg-ivory" />
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">{f.rango}</p>
            <p className="mt-2 max-w-3xl text-sm leading-relaxed text-graphite/75">{f.texto}</p>
          </div>
        ))}
      </div>
      <AppreciationChart data={d.aprecSeries} />
      <div>
        <SubTitle>Proyección de valor · Escenario base</SubTitle>
        <div className="mt-5">
          <FinTable
            testid="tabla-revalorizacion"
            columns={["Horizonte", "Valor del inmueble", "Incremento anual"]}
            rows={d.revalorizacion.proyeccion}
            rightFrom={1}
          />
        </div>
      </div>
      <Body className="text-graphite/60">{d.revalorizacion.cierre}</Body>
    </Chapter>

    <Chapter id="14" num="14" title="Retorno Total Actualizado">
      <Body>{d.retornoTotal.intro}</Body>
      <FinTable
        testid="tabla-retorno-total"
        columns={["Escenario", "ROI Cash", "Revalorización media anual", "Retorno total actualizado"]}
        rows={d.retornoTotal.tabla}
        rightFrom={1}
      />
    </Chapter>

    <Chapter id="15" num="15" title="Comparativa con Alternativas de Inversión">
      <Body>{d.comparativa.intro}</Body>
      <FinTable
        testid="tabla-comparativa"
        columns={["Alternativa", "Rentabilidad anual", "Liquidez", "Revalorización"]}
        rows={d.comparativa.rows}
        rightFrom={1}
        note={d.comparativa.nota}
      />
    </Chapter>

    <Chapter id="16" num="16" title="Plan de Salida">
      <Body>{d.planSalida.intro}</Body>
      <FinTable
        testid="tabla-plan-salida"
        columns={["Opción", "Cuándo", "Rentabilidad esperada"]}
        rows={d.planSalida.rows}
        rightFrom={1}
        note={d.planSalida.nota}
      />
    </Chapter>
  </>
);
